import { defineStore } from "pinia";

export const useTrainingSessionStore = defineStore('trainingSession', {
    state: () => ({
        trainingSession: {},
        trainingSessions: [],
    }),
    actions: {
        setTrainingSession(trainingSession) {
            this.trainingSession = trainingSession
        },
        setTrainingSessions(trainingSessions) {
            this.trainingSessions = trainingSessions
        },
        addTrainingSession(trainingSession) {
            this.trainingSessions.unshift(trainingSession)
        },
        updateTrainingSession(trainingSession) {
            let index = this.trainingSessions.findIndex(cl => cl.id === trainingSession.id)
            this.trainingSessions.splice(index, 1, trainingSession)
        },
        deleteTrainingSession(trainingSession) {
            let index = this.trainingSessions.findIndex(cl => cl.id === trainingSession.id)
            this.trainingSessions.splice(index, 1)
        },
    },
});